@use '../../style/globals.scss' as *;

.overlayWrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.overlayContentWrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 85%;
    max-width: 400px;
    padding: 30px 50px 40px;
    background-color: rgba(0, 0, 0, 0.9);
    font-family: $font_arise_primary;
    text-align: center;
    /* Shift up by the spinner's half-height (75px) + its top padding (30px) so the spinner center hits screen center */
    transform: translate(-50%, -105px);
    border-radius: 10px;
    box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.1);
}

.authCopy {
    margin-bottom: 1.5em;
}

.loginButton {
    color: black;
}

.logo {
    position: relative;
    width: 150px;
    height: 150px;
    margin-bottom: 20px;
}

.quickComplete {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 800;

    button {
        color: black;
    }
}

.questUnenrolledNotice {
    position: absolute;
    z-index: 1000;
    bottom: 20px;
    left: 20px;
    padding: 20px 20px;
    background-color: #000;
    color: white;
    font-size: 14px;
    border-radius: 5px;
    max-width: calc(100% - 40px);
    &.collapsed {
        padding: 0;
        background-color: transparent;
    }
    .enrolButton {
        background-color: #555;
        padding: 5px 10px;
        border-radius: 50px;
        font-size: 12px;
        font-weight: bold;
        margin-left: 10px;
        display: inline-block;
        cursor: pointer;
        &:first-child {
            margin-left: 0;
        }
    }
}
.info {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1000;
    color: black;
    background-color: white;
}
